export default __webpack_public_path__ + "img/hk_clockenflap-e348c3f2eb9045a22ac91ce432b4b364.png";